import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';

import { Encumbrance, Partner } from 'types';
import PageWithTabs, {
  Tab,
} from 'modules/_shared/components/Pages/PageWithTabs';
import { FixedShare } from '../types/Share';
import ShareEncumbranceView from '../ShareEncumbranceView';
import ShareTagView from '../ShareTagView';
import ShareEncumbranceDocumentsView from './ShareEncumbranceDocumentsView';

type Props = {
  page: number;
  share: FixedShare;
  partner: Partner;
  encumbrances: Encumbrance[];
  tag: any;
  setEncumbrances: any;
  setEncumbrancesUpdated: any;
  setTag: any;
  setTagUpdated: any;
  handleChangePage: any;
  isReadOnly?: boolean;
};

const UpdateSharesBody: FC<Props> = ({
  share,
  partner,
  encumbrances,
  tag,
  setEncumbrances,
  setEncumbrancesUpdated,
  setTag,
  setTagUpdated,
  isReadOnly,
}) => {
  const { t } = useTranslate();

  return (
    <Modal.Body
      style={{ minHeight: '500px', overflowY: 'auto', overflow: 'visible' }}
    >
      <div className="nk-modal gy-4">
        <PageWithTabs
          tabs={[
            {
              key: 'share-encumbrance-tab',
              icon: 'ni-coins',
              title: t('ShareEncumbrance'),
              content: (
                <ShareEncumbranceView
                  share={share}
                  encumbrances={encumbrances}
                  setEncumbrances={setEncumbrances}
                  setEncumbrancesUpdated={setEncumbrancesUpdated}
                  partner={partner}
                  isReadOnly={isReadOnly}
                />
              ),
            },
            !isReadOnly
              ? {
                  key: 'share-tag-tab',
                  icon: 'ni-tag',
                  title: t('ShareTag'),
                  content: (
                    <ShareTagView
                      share={share}
                      tag={tag}
                      setTag={setTag}
                      setTagUpdated={setTagUpdated}
                    />
                  ),
                }
              : (null as unknown as Tab),

            {
              key: 'share-documents-tab',
              icon: 'ni-file-docs',
              title: t('Documents'),
              content: (
                <ShareEncumbranceDocumentsView encumbrances={encumbrances} />
              ),
            },
          ].filter(Boolean)}
        />
      </div>
    </Modal.Body>
  );
};

export default UpdateSharesBody;
